// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}
.bw-card {
  border-radius: 12px;
  background: #fff;
  border: 1px solid #ededed;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 4px 12px rgba(0, 0, 0, 0.03);
  overflow: hidden;
  margin-bottom: 0.75rem;
}
.bw-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: linear-gradient(135deg, #eff6ff 0%, #f0f9ff 100%);
  border-bottom: 1px solid rgba(0, 95, 240, 0.08);
}
.bw-source-tag {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #005ff0;
}
.bw-stream-count {
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 0.65rem;
  font-weight: 700;
  background: rgba(0, 95, 240, 0.1);
  color: #005ff0;
}
.bw-hero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 16px;
}
.bw-hero-left {
  flex: 1;
  min-width: 0;
}
.bw-account-type {
  font-size: 1.15rem;
  font-weight: 700;
  color: #171717;
  line-height: 1.3;
  text-transform: capitalize;
}
.bw-applicant-line {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 6px;
  font-size: 0.78rem;
  color: #a3a3a3;
}
.bw-name-match {
  font-size: 1rem;
  line-height: 1;
  margin-top: 2px;
}
.bw-match-yes {
  color: #16a34a;
}
.bw-match-no {
  color: #dc2626;
}
.bw-name-rows {
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.bw-name-row {
  display: flex;
  align-items: baseline;
  gap: 5px;
}
.bw-applicant-label {
  font-weight: 600;
  color: #a3a3a3;
  font-size: 0.72rem;
}
.bw-applicant-value {
  font-weight: 700;
  color: #171717;
  font-size: 0.82rem;
}
.bw-hero-right {
  flex-shrink: 0;
  text-align: right;
  padding: 10px 14px;
  background: linear-gradient(135deg, #f0fdf4 0%, #f0f9ff 100%);
  border-radius: 6px;
  border: 1px solid rgba(22, 163, 74, 0.12);
}
.bw-hero-amount {
  font-size: 1.65rem;
  font-weight: 800;
  color: #16a34a;
  line-height: 1.1;
  letter-spacing: -0.02em;
}
.bw-hero-label {
  font-size: 0.65rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #a3a3a3;
  margin-top: 1px;
}
.bw-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  padding: 0 16px 14px;
}
.bw-stat {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 auto;
  min-width: 110px;
  padding: 8px 12px;
  border-radius: 6px;
  background: #fafafa;
  margin: 3px;
  transition: background 120ms ease;
}
.bw-stat:hover {
  background: #f5f5f5;
}
.bw-stat-icon {
  font-size: 1.1rem;
  line-height: 1;
  flex-shrink: 0;
}
.bw-stat-body {
  min-width: 0;
}
.bw-stat-label {
  font-size: 0.62rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #a3a3a3;
}
.bw-stat-value {
  font-size: 0.82rem;
  font-weight: 700;
  color: #171717;
}
.bw-danger {
  color: #dc2626;
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/income-wizard/phases/stream-phase/stream-types/banksync-wizard-detail.component.less"],"names":[],"mappings":"AAYA;EAAQ,cAAA;EAAgB,WAAA;AATxB;AAWA;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,yEAAA;EACA,gBAAA;EACA,sBAAA;AATF;AAYA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,6DAAA;EACA,+CAAA;AAVF;AAaA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AAXF;AAcA;EACE,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iCAAA;EACA,cAAA;AAZF;AAeA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,aAAA;AAbF;AAgBA;EAAgB,OAAA;EAAS,YAAA;AAZzB;AAcA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,0BAAA;AAZF;AAeA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AAbF;AAgBA;EAAiB,eAAA;EAAiB,cAAA;EAAgB,eAAA;AAXlD;AAYA;EAAgB,cAAA;AAThB;AAUA;EAAe,cAAA;AAPf;AAQA;EAAgB,aAAA;EAAe,sBAAA;EAAwB,QAAA;AAHvD;AAIA;EAAe,aAAA;EAAe,qBAAA;EAAuB,QAAA;AACrD;AAAA;EAAsB,gBAAA;EAAkB,cAAA;EAAwB,kBAAA;AAKhE;AAJA;EAAsB,gBAAA;EAAkB,cAAA;EAAyB,kBAAA;AASjE;AAPA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,6DAAA;EACA,kBAAA;EACA,yCAAA;AASF;AANA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;AAQF;AALA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;AAOF;AAJA;EACE,aAAA;EACA,eAAA;EACA,MAAA;EACA,oBAAA;AAMF;AAHA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,iCAAA;AAKF;AAHE;EAAU,mBAAA;AAMZ;AAHA;EAAgB,iBAAA;EAAmB,cAAA;EAAgB,cAAA;AAQnD;AAPA;EAAgB,YAAA;AAUhB;AARA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AAUF;AAPA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AASF;AANA;EAAa,cAAA;AASb","sourcesContent":["@uds-blue-70: #005ff0;\n@uds-green-70: #16a34a;\n@uds-red-70: #dc2626;\n@uds-neutral-10: #fafafa;\n@uds-neutral-20: #f5f5f5;\n@uds-neutral-30: #ededed;\n@uds-neutral-50: #a3a3a3;\n@uds-neutral-100: #171717;\n@uds-radius: 12px;\n@uds-radius-sm: 6px;\n@uds-ease: 120ms ease;\n\n:host { display: block; width: 100%; }\n\n.bw-card {\n  border-radius: @uds-radius;\n  background: #fff;\n  border: 1px solid @uds-neutral-30;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 4px 12px rgba(0, 0, 0, 0.03);\n  overflow: hidden;\n  margin-bottom: 0.75rem;\n}\n\n.bw-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 16px;\n  background: linear-gradient(135deg, #eff6ff 0%, #f0f9ff 100%);\n  border-bottom: 1px solid rgba(0, 95, 240, 0.08);\n}\n\n.bw-source-tag {\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: @uds-blue-70;\n}\n\n.bw-stream-count {\n  padding: 3px 10px;\n  border-radius: 999px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  background: rgba(0, 95, 240, 0.1);\n  color: @uds-blue-70;\n}\n\n.bw-hero {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 16px;\n}\n\n.bw-hero-left { flex: 1; min-width: 0; }\n\n.bw-account-type {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: @uds-neutral-100;\n  line-height: 1.3;\n  text-transform: capitalize;\n}\n\n.bw-applicant-line {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-top: 6px;\n  font-size: 0.78rem;\n  color: @uds-neutral-50;\n}\n\n.bw-name-match { font-size: 1rem; line-height: 1; margin-top: 2px; }\n.bw-match-yes { color: @uds-green-70; }\n.bw-match-no { color: @uds-red-70; }\n.bw-name-rows { display: flex; flex-direction: column; gap: 1px; }\n.bw-name-row { display: flex; align-items: baseline; gap: 5px; }\n.bw-applicant-label { font-weight: 600; color: @uds-neutral-50; font-size: 0.72rem; }\n.bw-applicant-value { font-weight: 700; color: @uds-neutral-100; font-size: 0.82rem; }\n\n.bw-hero-right {\n  flex-shrink: 0;\n  text-align: right;\n  padding: 10px 14px;\n  background: linear-gradient(135deg, #f0fdf4 0%, #f0f9ff 100%);\n  border-radius: @uds-radius-sm;\n  border: 1px solid rgba(22, 163, 74, 0.12);\n}\n\n.bw-hero-amount {\n  font-size: 1.65rem;\n  font-weight: 800;\n  color: @uds-green-70;\n  line-height: 1.1;\n  letter-spacing: -0.02em;\n}\n\n.bw-hero-label {\n  font-size: 0.65rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: @uds-neutral-50;\n  margin-top: 1px;\n}\n\n.bw-stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0;\n  padding: 0 16px 14px;\n}\n\n.bw-stat {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1 1 auto;\n  min-width: 110px;\n  padding: 8px 12px;\n  border-radius: @uds-radius-sm;\n  background: @uds-neutral-10;\n  margin: 3px;\n  transition: background @uds-ease;\n\n  &:hover { background: @uds-neutral-20; }\n}\n\n.bw-stat-icon { font-size: 1.1rem; line-height: 1; flex-shrink: 0; }\n.bw-stat-body { min-width: 0; }\n\n.bw-stat-label {\n  font-size: 0.62rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: @uds-neutral-50;\n}\n\n.bw-stat-value {\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: @uds-neutral-100;\n}\n\n.bw-danger { color: @uds-red-70; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
